<script>
export default {
  name: 'PaginationItemsRange',
  props: {
    countItems: {
      type: Number,
      default: 10,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    startRow() {
      return this.page * this.countItems - this.countItems + 1;
    },
    endRow() {
      return this.page * this.countItems > this.totalItems
        ? this.totalItems
        : this.page * this.countItems;
    },
  },
  i18n: {
    messages: {
      en_US: {
        loading: 'Loading...',
        range: '<b>{startRow}-{endRow}</b> out <b>{totalItems}</b> items',
      },
      es_ES: {
        loading: 'Cargando...',
        range: '<b>{startRow}-{endRow}</b> de <b>{totalItems}</b> ítems',
      },
      pt_BR: {
        loading: 'Carregando...',
        range: '<b>{startRow}-{endRow}</b> de <b>{totalItems}</b> itens',
      },
    },
  },
};
</script>

<template>
  <div
    v-if="loading"
    class="cxm-PaginationItemsRange"
  >
    {{ $t('loading') }}
  </div>
  <div
    v-else
    class="cxm-PaginationItemsRange"
    v-html="$t('range', { startRow, endRow, totalItems })"
  />
</template>

<style lang="scss">
.cxm-PaginationItemsRange {
  color: var(--track-color-bluegray-80);
  font-size: var(--track-font-size-xs);
  font-weight: var(--track-font-weight-regular);

  & > b {
    font-weight: var(--track-font-weight-medium);
  }
}
</style>
